<template>
  <div class="group-fields--container">
    <div class="input-block mrg-t-15">
      <label>Хэш группы</label>
      <input
          type="text"
          @focus="hashId.error = ''"
          @blur="vHash"
          v-model="hashId.model"
          required
      />
      <div class="form-error">{{ hashId.error }}</div>
      <div class="hint">Хэш группы может содержать только латинские буквы и цифры без каких-либо символов</div>
    </div>
    <div class="input-block">
      <label>Название группы</label>
      <input
          type="text"
          @focus="name.error = ''"
          @blur="vName"
          v-model="name.model"
          required
      />
      <div class="form-error">{{ name.error }}</div>
    </div>
    <div class="input-block">
      <label>
        <input
            type="checkbox"
            @change="emitData"
            v-model="useUserTg"
        />
        Использовать данную группировку для Telegram-бота
      </label>
      <div class="hint">
        Если у вас есть свой Telegram-бот и настроена интеграция для того, чтобы клиенты могли получать уведомления
        и записываться, то вы можете использовать данный чек-бокс, чтобы данная ссылка отправлялась клиентам вместо
        общей, которая ведет на все компании
      </div>
    </div>
    <div class="input-block">
      <label>Выберите компании, которые будут входить в группировку</label>
      <simple-select-checkbox
          :dataComponent="companies"
          :default="defaultCompanyIds"
          @changeValue="changeCompanyIds"
      ></simple-select-checkbox>
    </div>
  </div>
</template>
<script>
import SimpleSelectCheckbox from "../../SimpleSelectCheckbox.vue";
import Validator from "../../libraries/Validator";

const validator = new Validator();

export default {
  name: "GroupFields",
  components: {SimpleSelectCheckbox},
  data() {
    return {
      hashId: {model: '', error: ''},
      name: {model: '', error: ''},
      useUserTg: false,
      companyIds: [],
    };
  },
  props: {
    companies: Array,
    defaultCompanyIds: Array,
    defaultValues: Object,
  },
  watch: {
    defaultValues: {
      handler (val) {
        this.hashId.model = val.hash_id;
        this.name.model = val.name;
        this.useUserTg = val.use_user_tg;
      },
      deep: true
    },
    hashId: {
      handler () {
        this.emitData();
        this.emitValidate();
      },
      deep: true
    },
    name: {
      handler () {
        this.emitData();
        this.emitValidate();
      },
      deep: true
    },
  },
  computed: {
    validateData() {
      let errorCount = 0;
      this.vHash().result === "error" ? errorCount++ : "";
      this.vName().result === "error" ? errorCount++ : "";
      return errorCount;
    },
  },
  methods: {
    vHash() {
      let validate = validator.validate([
        {
          fieldName: "Хэш группы",
          value: this.hashId.model,
          type: "required",
          length: 20
        },
      ]);
      validate.result === "error"
          ? (this.hashId.error = validate.message)
          : (this.hashId.error = "");
      return validate;
    },
    vName() {
      let validate = validator.validate([
        {
          fieldName: "Название группы",
          value: this.name.model,
          type: "required",
          length: 120
        },
      ]);
      validate.result === "error"
          ? (this.name.error = validate.message)
          : (this.name.error = "");
      return validate;
    },
    emitData() {
      this.$emit(
          'updateData',
          {
            hash_id: this.hashId.model,
            name: this.name.model,
            use_user_tg: this.useUserTg,
            company_ids: this.companyIds
          }
      );
    },
    emitValidate() {
      this.$emit('validateData', this.validateData <= 0);
    },
    changeCompanyIds(val) {
      this.companyIds = val;
      this.emitData();
    },
  }
};
</script>

<style scoped lang="less">

</style>